namespace RioERP.Orders {
    export interface FranchiseePayoutResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        PaidAmount?: number;
        ErrorList?: string[];
    }
}
